import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

export const TotemLabel = ({ className, ...props }: React.ComponentProps<typeof Label>) => {
    return (
        <Label className={cn('font-extrabold text-foreground text-sm uppercase tracking-wide', className)} {...props} />
    );
};
